import React, { Fragment, Component } from "react";
import styles from "./Signature.module.sass";
import theme from "../../App.module.sass";
import TitleSection from "../../components/TitleSection/TitleSection";

import api from "../../utils/api";

import DragAndDrop from "../../components/DragAndDrop/DragAndDrop";
import MobileDragAndDrop from "../../components/DragAndDrop/MobileDragAndDrop";
import mediaQuery from "../../utils/mediaQuery";
import SignatureType from "../../components/SignatureType/SignatureType";
import AppContext from "../../contexts/appContext";
import SignatureBillet from "../../components/SignatureBillet/SignatureBillet";
import { Link } from "react-router-dom";

class Signature extends Component {
  state = {
    documents: [],
    isDesktop: false,
    signStarted: false,
    signatureType: "",
  };

  static contextType = AppContext;

  processCode;

  backButtonListener = () => {
    this.context.setContext({
      ...this.context,
      error: {
        show: true,
        msg:
          "Já vai embora? Caso volte ou feche essa janela você irá recomeçar sua compra.",
        showOptions: true,
        onBack: () => {
          this.context.setContext({
            ...this.context,
            error: {
              show: false,
            },
          });

          this.props.history.push({
            pathname: "/produtos",
          });
        },
        onCancel: () => {
          this.context.setContext({
            ...this.context,
            error: {
              show: false,
            },
          });
          window.history.pushState(null, null, null);
        },
        onHide: () => {
          this.props.history.push({
            pathname: "/produtos",
          });
        },
      },
    });
  };

  componentDidMount() {
    this.processCode = this.context.selectedIdentifier === "cpf" ? 1001 : 1002;
    api
      .get(
        api.endpoints.LISTA_DOCUMENTOS,
        { codigo: this.processCode },
        { produto: this.context.product.id === "1" ? "601" : "611" }
      )
      .then((result) => {
        if (result.data.documentos) {
          this.setState({ documents: result.data.documentos });
        }
      });

    if (
      mediaQuery.watchIfDesktop((e) => this.setState({ isDesktop: e.matches }))
    ) {
      this.setState({
        isDesktop: true,
      });
    }

    window.history.pushState(null, null, null);
    window.addEventListener("popstate", this.backButtonListener);
    window.dataLayer.push({
      event: "Cons.Proposta",
      Nproposta: this.context.proposalCode,
    });
  }

  componentWillUnmount() {
    mediaQuery.unsubscribe();
    window.removeEventListener("popstate", this.backButtonListener);
  }
  render() {
    let titleNumbers = 0;
    const nextTitleNum = () => {
      titleNumbers += 1;
      return titleNumbers;
    };
    return (
      <Fragment>
        <div className={theme.contentColumns}>
          <div className={theme.mainContent}>
            {this.context.paymentType === "BB" ? (
              <>
                <p className={styles.subHeader}>
                  Para finalizar sua contratação, precisamos que você realize 3
                  passos importantes. Vamos lá?{" "}
                </p>
                <section className={theme.sectionForm}>
                  <TitleSection
                    title={`${nextTitleNum()}. Realize o pagamento do seu boleto`}
                  />
                  <SignatureBillet
                    bb={this.context.paymentType === "BB"}
                    proposta={this.context.proposalCode}
                    cotationCode={this.context.cotationBusinessCode}
                    document={this.context.document}
                  />
                </section>
              </>
            ) : (
              <p className={styles.subHeader}>
                Para finalizar sua contratação, precisamos que você realize 2
                passos importantes. Vamos lá?{" "}
              </p>
            )}

            <section className={theme.sectionForm}>
              <TitleSection
                title={`${nextTitleNum()}. Faça a sua assinatura`}
              />
              <p>
                Ela é digital e é finalizada em nosso site parceiro. Escolha
                como prefere começar:
              </p>
              <SignatureType signatureChosen={this.signatureHandler} />
            </section>
            <section className={theme.sectionForm}>
              <TitleSection
                title={`${nextTitleNum()}. Envie seus documentos`}
              />
              <p>
                Os documentos pedidos aqui e os dados que estão nele, servem
                exclusivamente para a manutenção do seu contrato. Saiba mais em
                nossa{" "}
                <a
                  rel="noopener noreferrer"
                  href="http://caixasegurosholding.force.com/portalprivacidade"
                  target="_blank"
                >
                  Política de Privacidade.
                </a>
              </p>
              <p>
                Para começar, envie fotos frente e verso do seu documento de
                identificação. Lembre-se de se certificar de que todas as
                informações estejam legíveis.
              </p>
              <div className={styles.docsList}>
                {this.state.documents.map((doc, index) => {
                  return this.state.isDesktop ? (
                    <DragAndDrop
                      key={index}
                      context={this.context}
                      title={doc.apelidoDocumento}
                      processCode={this.processCode}
                      cpfCnpj={this.context.document}
                      proposalCode={this.context.proposalCode}
                      document={doc}
                    />
                  ) : (
                    <MobileDragAndDrop
                      key={index}
                      context={this.context}
                      title={doc.apelidoDocumento}
                      processCode={this.processCode}
                      cpfCnpj={this.context.document}
                      proposalCode={this.context.proposalCode}
                      document={doc}
                    />
                  );
                })}
              </div>
            </section>
            <Link
              to="/produtos"
              className={[theme.link, styles.newSimulation].join(" ")}
            >
              {" "}
              Fazer uma nova simulação{" "}
            </Link>
          </div>
        </div>
      </Fragment>
    );
  }

  signatureHandler = (type) => {
    const requestBody = {
      tipo: type,
      produto: {
        codigo: this.context.product.id === "1" ? "601" : "611",
      },
      pessoa: {
        codigo: this.context.document,
      },
      urlRetorno: "https://www.google.com.br/",
      codUsuario: api.CODIGO_USUARIO(),
    };

    api
      .post(api.endpoints.ASSINATURA, requestBody, {
        proposta: this.context.proposalCode,
      })
      .then((result) => {
        if (type === "SMS") {
          window.open(result.data.urlAssinatura, "_blank");
        }

        this.setState({ signStarted: true });
        this.setState({ signatureType: type });
      });
  };
}

export default Signature;
